/** Hook to load the region configuration on mount. */

import { useEffect, useState } from "react";

import { apiClient } from "../api/client";
import { ApiError, type RegionConfig } from "../types";

interface UseConfigResult {
  config: RegionConfig | null;
  loading: boolean;
  error: string | null;
}

export function useConfig(): UseConfigResult {
  const [config, setConfig] = useState<RegionConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiClient
      .getConfig()
      .then((cfg) => {
        if (!cancelled) {
          setConfig(cfg);
          setError(null);
        }
      })
      .catch((err: ApiError | Error) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading, error };
}